var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkIcon = function SvgExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#external-link-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.862 7.529A.667.667 0 0 1 14 8v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a.667.667 0 0 1 0 1.333H4A.667.667 0 0 0 3.333 4v8a.667.667 0 0 0 .667.667h8a.667.667 0 0 0 .667-.667V8c0-.177.07-.346.195-.471M11.72 3.333h-1.053a.667.667 0 1 1 0-1.333h2.666a.667.667 0 0 1 .667.667v2.666a.667.667 0 0 1-1.333 0V4.28L8.473 8.467a.667.667 0 0 1-1.092-.217.67.67 0 0 1 .146-.73z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "external-link-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgExternalLinkIcon;